import { Autocomplete, TextField } from "@mui/material";
import Loader from "components/Loader";
import React from "react";
import { useGetCustomerDropdownQuery } from "state/api";
import EditCustomer from "./EditCustomer";

const CustomerDetails = ({carId,setLoader}) => {
  const [customer, setCustomer] = React.useState(null);
  const { data, isLoading } = useGetCustomerDropdownQuery();

  if (isLoading) return <Loader />;

  return (
    <div className="grid grid-cols-1 gap-4 mb-4 p-2 mx-auto">
      <Autocomplete
        style={{
          maxWidth: "900px",
        }}
        onChange={(event, newValue) => {
          setCustomer(newValue);
        }}
        options={data}
        getOptionLabel={(option) => option.customer}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Customer"
            placeholder="Customer"
          />
        )}
      />
      {customer && (
        <>
          <br />

          <EditCustomer customer={customer} carId={carId} setLoader={setLoader} />
        </>
      )}
    </div>
  );
};

export default CustomerDetails;
